import {
    Grid,
    Card,
    CardContent,
    CardActionArea,
    CardMedia,
    Typography,
    Box,
} from "@mui/material";
import React from "react";
import card from './ProjectInfo/AnalyticsInfo';
import './Projects.css';

export default function Analytics() {

    return (

        <div>
            <Box ml={5} mr={5} pl={7} pr={3} mt={3} pt={3} mb={1} pb={1}>
                <Grid
                    container
                    spacing={3}
                    alignContent="flex-start"
                    justifyContent="center"
                    // marginleft={40}
                    // marginright={40}
                >
                    {card.map((card, _) => {
                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={card.id}>
                                <CardActionArea>
                                    <Card
                                        variant="outlined"
                                        className="comCard"
                                    >
                                        <CardMedia
                                            component="img"
                                            sx={{ height: "500" }}
                                            image={card.image}

                                        />
                                        <CardContent className="comContent">
                                            <Typography align="left" style={{ fontFamily: "Lilita One", fontWeight: "80", fontSize: "24px", backgroundColor: "#098561", lineHeight: "25px", marginBottom: "10px" }}>
                                                &nbsp;&nbsp;Project:  {card.title}&nbsp;&nbsp;
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: "18px", lineHeight: "19px", fontWeight: "500" }}>
                                                <span style={{ fontWeight: "750" }}>About:</span> {card.Desc}
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: "18px", marginTop: "4px", fontWeight: "500" }}>
                                                <span style={{ fontWeight: "750" }}>Stack Used:</span> {card.stack}
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: "18px", fontWeight: "500" }}>
                                                <a href={card.Github} style={{ color: "#CB9D06" }}>Github</a>
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: "18px", fontWeight: "500", marginBottom: "4px" }}>
                                                <a href={card.Link} style={{ color: "#CB9D06" }}>
                                                    Link
                                                </a>
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: "18px", lineHeight: "19px", fontWeight: "500" }}>
                                                <span style={{ fontWeight: "850" }}>Mentions:</span> {card.Mentions}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </CardActionArea>

                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </div>
    );
}